import { render } from "./ImportExportCatalogFunction.vue?vue&type=template&id=8d0e7cf6&scoped=true&ts=true"
import script from "./ImportExportCatalogFunction.vue?vue&type=script&lang=ts"
export * from "./ImportExportCatalogFunction.vue?vue&type=script&lang=ts"

import "./ImportExportCatalogFunction.vue?vue&type=style&index=0&id=8d0e7cf6&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d0e7cf6"]])

export default __exports__